module.exports = __webpack_public_path__ + "img/wallet_01_lake.005e9fe9.jpg";